export default "__VITE_ASSET__BkBeu9gR__"